import React, { useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import store from 'src/storeWire';
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import System from 'src/helper/system';
import { useProductStore } from 'src/hooks/product';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';

const CartItemReplacePopup = (props) => {
    const { SetStatus } = props;
    const { product, isFrom = false, cartReplaceItem, isFromManualCart = false } = props.data;
    const [{ }, {  }, { ADD_TO_CART }] = useCartStore();
    const [{ }, { get_pricing_by_id, get_current_price_by_quantity }, { }] = useProductInventoryPriceStore();
    const [loader, setLoader] = useState(false)
    const [{ productList }, { }, { }] = useProductStore();
    const { translation: t } = System;

    const replaceCartItem = async () => {
        setLoader(true)

        const payload = {
            ...cartReplaceItem,
            'isReplace': true
        }
        const res = await ADD_TO_CART(payload, isFrom, product, isFromManualCart);
        setTimeout(() => {
            setLoader(false)
        }, 1500);
        // cartReplaceItem = { ...cartReplaceItem, cartReplacedPrice: get_current_price_by_quantity(get_pricing_by_id({ ItemNumber: cartReplaceItem.ItemNumber }), cartReplaceItem.totalQuantity).marketPrice };
        // if (!backorder_not_available(productList[cartReplaceItem?.ItemNumber]) && cartReplaceItem.backOrderedQuantity > 0) {


        //     System.popup('InventoryAlertForAddToCartPopup', {
        //         single_product: [cartReplaceItem],
        //         isReplaceCart: true,
        //         productAddedToCartCallback: data.productAddedToCartCallback,
        //         isFrom: isFrom,
        //         addToCartParam: cartReplaceItem
        //     })

        //     setLoader(false)
        // } else {
        //     await replace_cart_in_Bulk({"cartItems": [cartReplaceItem]});
        //     setTimeout(() => {
        //         setLoader(false)
        //     }, 1500);
        // }
    }

    const getUnitPrice = () => {
        return System.getFormatNumber({ amount: Number(get_current_price_by_quantity(get_pricing_by_id({ ItemNumber: cartReplaceItem.ItemNumber }), cartReplaceItem.quantity).marketPrice) });
    };

    return (
        <>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                            store.dispatch(SET_ADD_CART_DATA(false))
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{t('customerPartNumber')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <p>{t('itemExistsWithADifferentCPN')}</p>

                        <div className="table-responsive mb-4">
                            <table className="bs5 table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th><span>{t('product')}</span></th>
                                        <th><span>{t('CPN')}</span></th>
                                        <th><span>{t('manufacturer')}</span></th>
                                        <th><span>{t('quantity')}</span></th>
                                        <th><span>{t('price')}</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="align-middle">
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.ERPMFRPartNumber && cartReplaceItem.ERPMFRPartNumber}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.cpn && cartReplaceItem.cpn}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.ManufacturerName && cartReplaceItem.ManufacturerName}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{cartReplaceItem.quantity && cartReplaceItem.quantity}</div>
                                        </td>
                                        <td>
                                            <div className='font-12'>{getUnitPrice()}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary w145"
                                data-bs-toggle="modal"
                                onClick={() => {
                                    SetStatus(false)
                                    store.dispatch(SET_ADD_CART_DATA(false))
                                }}>
                                {t('cancel')}
                            </button>
                            {loader &&
                                <button type="submit" className="bs5 btn btn-primary w145"
                                    data-bs-toggle="modal" disabled={true}>
                                    <i className="fa fa-spinner fa-spin" />
                                </button>
                            }

                            {!loader &&
                                <button type="submit" className="bs5 btn btn-primary w145"
                                    data-bs-toggle="modal"
                                    onClick={() => { replaceCartItem() }}>
                                    {t('replace')}
                                </button>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CartItemReplacePopup;